@if (config$ | ngrxPush; as config) {
    @for (fieldConfig of config.noSectionFields; track fieldConfig.path) {
        <ng-container
            *ngTemplateOutlet="
                fieldsTmpl;
                context: { fieldConfig: fieldConfig }
            "
        ></ng-container>
    }

    @for (section of config.sectionFields; track section.sectionName) {
        <div
            class="g-col-12 fw-bold mt-2"
            [title]="section.sectionName | translateTokenisedString"
        >
            {{ section.sectionName | translateTokenisedString }}
        </div>

        @for (fieldConfig of section.fields; track fieldConfig.path) {
            <ng-container
                *ngTemplateOutlet="
                    fieldsTmpl;
                    context: { fieldConfig: fieldConfig }
                "
            ></ng-container>
        }
    }
}

<ng-template #fieldsTmpl let-fieldConfig="fieldConfig"
    ><div class="d-flex flex-column g-col-6 g-col-md-3">
        <div class="mb-1" [title]="fieldConfig.name | translateTokenisedString">
            <div class="text-truncate">
                {{ fieldConfig.name | translateTokenisedString }}
            </div>
        </div>
        @let fieldValue = data && data[fieldConfig.path];
        <div class="d-flex flex-grow-1 align-items-center">
            @switch (fieldConfig.fieldType) {
                @case (ViewColumnType.Currency) {
                    <div class="me-2">
                        {{ formatCurrency(fieldValue) ?? `&mdash;` }}
                    </div>
                }
                @case (ViewColumnType.Date) {
                    @let dateStr =
                        fieldValue
                            | dateTime
                                : {
                                      locale: locale?.code,
                                      format: WdxDateFormat.AbsoluteDate,
                                  };
                    <div class="me-2" [attr.title]="dateStr">
                        {{ dateStr }}
                    </div>
                }
                @case (ViewColumnType.DateTime) {
                    @let dateStr =
                        (fieldValue
                            | dateTime
                                : {
                                      locale: locale?.code,
                                      format: WdxDateFormat.AbsoluteDateTime,
                                  }) ?? fieldValue;
                    <div class="me-2" [attr.title]="dateStr">
                        {{ dateStr }}
                    </div>
                }
                @default {
                    <div
                        class="me-2 text-wrap overflow-auto portfolio-detail__field"
                        [attr.title]="fieldValue"
                    >
                        {{ (fieldValue | isNil) ? `&mdash;` : fieldValue }}
                    </div>
                }
            }

            @if (fieldConfig.isCopyable) {
                <wdx-copy-to-clipboard [copyValue]="fieldValue" />
            }
        </div>
    </div>
</ng-template>
